import { render, staticRenderFns } from "./CreatingAccount.vue?vue&type=template&id=53c39356"
import script from "./CreatingAccount.vue?vue&type=script&lang=js"
export * from "./CreatingAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports